import React, {Component} from 'react';

import {ContactIndicator, ContactStyle} from '../../Decorators/Checkmarks'
import {timeAgo} from '../../timeFunctions/timeFns'
import { RenderBattVolt } from '../RenderHelpers';
import { sanitizeDateTime } from '../../timeFunctions/timeFns';

import './devicestatuspanel.css'

export default class DeviceStatusPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
    this.displayIndex = undefined;
  }
  findDisplay () {
    if (!Array.isArray(this.props.deviceData))
      return undefined;
    const short = this.props.deviceData[0]
    const activeType = short?.SensorType1 !== 'FF' ? short?.SensorType1 :
      short?.SensorType2 !== 'FF' ? short?.SensorType2 :
      short?.SensorType3 !== 'FF' ? short?.SensorType3 : undefined
    if (activeType === undefined)
      return undefined
    const index = this.props?.deviceConfig?.sensors.findIndex (s=>s.sensor_type === activeType)
    return index
  }
  countFactor () {
    this.displayIndex = this.findDisplay()
    return this.displayIndex !== undefined ? this.props.deviceConfig.sensors[this.displayIndex]?.factor : ''
  }
  battPercent (volt) {
    return isNaN(volt) ? "N/A" : Math.floor(Math.min(Math.max(volt - 2, 0) * 100, 100)) + "%"
  }
  lqFormat (lq) {
    return isNaN(lq) ? "N/A" : lq
  }

  secondRow () {
    return (
      <>
      <div className="status-row">
      <span className="status-cell status-text">{this.countFactor()}</span>
      <span className="status-cell status-text">
        {this.displayIndex !== undefined ? 
          this.props.deviceConfig.sensors[this.displayIndex]?.initial_meter_read: ''}
      </span>
      <span className="status-cell">
        {this.displayIndex !== undefined ? 
          this.props.deviceConfig.sensors[this.displayIndex]?.display_type.replaceAll('_',' '): ''}
      </span>
      </div>
      <div className="status-caption-row">
      <div className="status-cell status-caption">Count Factor</div>
      <div className="status-cell status-caption">IMR</div>
      <span className="status-cell status-caption">Sensor Type</span>
      </div>
      </>
    )
  }
  thirdRow() {
    const pc = this.props?.dcfg
    const model = pc?.Config_As ?? 'MDT'
    const range = pc?.isMax === 'T' ? "Max" : "Standard"
    const mfgDate = pc?.FQA_Date ? sanitizeDateTime(pc.FQA_Date).toLocaleDateString() : "Not Available"
    return (
      <>
      <div className="status-row">
        <span className="status-cell status-text">{model}</span>
        <span className="status-cell status-text">{range}</span>
        <span className="status-cell">{mfgDate}</span>
      </div>
      <div className="status-caption-row">
        <span className="status-cell status-caption">Model No.</span>
        <span className="status-cell status-caption">Range</span>
        <span className="status-cell status-caption">Mfg Date</span>
      </div>
      </>
    )
  }
  render() {
    //console.log (this.props)
    const battVolt = this.props.deviceMeta[0]?.BattVolt
    const lq = this.props.deviceMeta[0]?.LinkQuality
    const lqIcon = Math.min(Math.floor((lq ?? 0)/ 20), 4);
    let lastContact = new Date(2021, 0, 1)
    let displayTime = "Not Available"
    //let displayTZ = ''
    const dtOptions = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    if (this.props.deviceMeta[0]?.ReadTime) {
      lastContact = sanitizeDateTime(this.props.deviceMeta[0].ReadTime, {zone: 'UTC'})
      //const dateObj = convertUTCToZoneTime(lastContact, dcapTZ);
      displayTime = lastContact.toLocaleString("en-US", dtOptions)
      // displayTZ = tzDisplay(dcapTZ)
    }
    else if (this.props.deviceConfig?.LatestData?.RXTime) {
      lastContact = sanitizeDateTime(this.props.deviceConfig?.LatestData?.RXTime, {zone:'UTC'})
      //const dateObj = convertUTCToZoneTime(lastContact, dcapTZ);
      displayTime = lastContact.toLocaleString("en-US", dtOptions)
      //displayTZ = tzDisplay(dcapTZ)
    }
    const captions = ["Node is powered and working properly", 
      "No node contact in last day",
      "No recent node contact"]
    return (
      <div className="container-fluid device-status">
        <span className="status-last-main">Last Reading</span>
        <span className="status-data"> {displayTime}</span>
        <div className="status-row">
          <span className="status-cell">{ContactIndicator(lastContact)}</span>
          <span className="status-cell">
            <img src={"signal"+lqIcon+".png"} alt="signal" width="40" height="40"></img>
          </span>
          <span className="status-cell">{RenderBattVolt(battVolt, "2x")}</span>
        </div>

        <div className="status-caption-row">
          <div className="status-cell status-caption">{captions[ContactStyle(timeAgo(lastContact))]}</div>
          <div className="status-cell status-caption">Link Quality {this.lqFormat(lq)}</div>
          <span className="status-cell status-caption">Battery {this.battPercent(battVolt)}</span>
        </div>
        {this.secondRow()}
        {this.thirdRow()}
      </div>
    );
  }
}

